import React, { useState } from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import TenantManagement from './TenantManagement';
import UserManagement from './UserManagement';

// Simple AuthContext mock
const mockAuthContext = {
  currentUser: { email: 'suhani1110jazz@gmail.com' },
  isSuperAdmin: true,
  loading: false
};

// Mock useAuth hook
const useAuth = () => mockAuthContext;

// Override the useAuth import for the components
window.useAuth = useAuth;

const AdminTest = () => {
  const [currentView, setCurrentView] = useState('home');

  const renderView = () => {
    switch(currentView) {
      case 'tenant':
        return <TenantManagement />;
      case 'user':
        return <UserManagement />;
      default:
        return (
          <Container maxWidth="md">
            <Box sx={{ textAlign: 'center', mt: 4 }}>
              <Typography variant="h4" gutterBottom>
                Admin Panel
              </Typography>
              <Typography variant="body1" sx={{ mb: 4 }}>
                Choose an admin function:
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                <Button 
                  variant="contained" 
                  color="primary"
                  onClick={() => setCurrentView('tenant')}
                  sx={{ minWidth: 200, py: 2 }}
                >
                  Tenant Management
                </Button>
                <Button 
                  variant="contained" 
                  color="secondary"
                  onClick={() => setCurrentView('user')}
                  sx={{ minWidth: 200, py: 2 }}
                >
                  User Management
                </Button>
              </Box>
            </Box>
          </Container>
        );
    }
  };

  return (
    <div>
      {currentView !== 'home' && (
        <Box sx={{ p: 2, backgroundColor: '#f5f5f5' }}>
          <Button 
            variant="outlined" 
            onClick={() => setCurrentView('home')}
          >
            ← Back to Admin Home
          </Button>
        </Box>
      )}
      {renderView()}
    </div>
  );
};

export default AdminTest;